<template>
  <div class="programmes-wrap">
    <!-- {{ugProgrammes}} -->
    <div class="block">
      <!-- <input v-model="searchTerm" type="text"> -->
      <!-- {{filteredProgrammes}} -->
      <search-filter
        :searchTerm.sync="searchTerm"
        :studyLevel.sync="studyLevel"
        :qualType.sync="qualType"
        :studyType.sync="studyType"
        postgrad="true"
      />

      <div v-if="filteredProgrammes.length === 0 && searchTerm.length">
        <p>
          No results found for <strong>{{ searchTerm }}</strong>,
          <a href="/study/programmes-courses/postgraduate-subjects">search our subjects.</a>
        </p>
      </div>

      <div v-else-if="filteredProgrammes.length === 0">
        <p>No results found.</p>
      </div>

      <pgprogramme
        v-for="(prog, index) in filteredProgrammes"
        :key="prog.pageID"
        :prog="prog"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import pgprogramme from "./PGProgramme.vue";
import searchFilter from "./SearchFilter.vue";

export default {
  name: "PgProgrammes",
  props: ["pgProgrammes"],
  components: {
    pgprogramme,
    searchFilter,
  },
  data() {
    return {
      searchTerm: "",
      studyLevel: "",
      qualType: "",
      studyType: "",
    };
  },
  computed: {
    filteredProgrammes() {
      let filteredProgs = this.pgProgrammes.filter((prog) => {
        return prog.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      });
      // let orderedStories = filteredStories.sort( ( a, b ) => {
      //   return b.upvoted - a.upvoted;
      // } )
      // return orderedStories;
      let alphabetisedProgs = filteredProgs.sort((a, b) => {
        if( a.name.includes('Doctor of Philosophy') && (this.studyLevel == 'Doctor' || this.qualType == 'Research' )) {
          return -1;
        } else {
        return a.name.localeCompare(b.name);
        }
        // return a.name.localeCompare(b.name);
      });
      // return alphabetisedProgs

      // return filteredProgs;

      // if level filter use and return results else show all sorted by alpha
      if (this.studyLevel) {
        let levelFilter = alphabetisedProgs.filter((prog) => {
          return prog.name
            .toLowerCase()
            .includes(this.studyLevel.toLowerCase());
        });

        alphabetisedProgs = levelFilter;
      }

      if (this.qualType) {
        let qualFilter = alphabetisedProgs.filter((prog) => {
          if (prog.qualType) {
            return prog.qualType.toLowerCase() === this.qualType.toLowerCase();
          }
        });
        alphabetisedProgs = qualFilter;
      }

      if (this.studyType) {
        let studyFilter = alphabetisedProgs.filter((prog) => {
          //does data exist
          if (prog.partTimeQual || prog.fillTimeQual) {
            if (this.studyType.toLowerCase().includes("part")) {
              return prog.partTimeQual.toLowerCase() === "yes";
            }

            if (this.studyType.toLowerCase().includes("full")) {
              return prog.fullTimeQual.toLowerCase() === "yes";
            }
          }
        });
        alphabetisedProgs = studyFilter;
      }

      return alphabetisedProgs;
    },
    pushPhd() {
      let array = this.pgProgrammes;
      let phds = [
        {
          name: "Doctor of Philosophy",
          type: "programme",
          orphan: true,
          url: "https://www.wgtn.ac.nz/fgr/prospective-phds",
          code: "PhD",
          trimester: "8",
          courses: "2",
          pageId: "doctor-philosophy",
          description:
            "Create knowledge and make discoveries that make a difference to the world while you develop new skills to further your career as a researcher.",
          keyDateSet: [
            {
              applyDate: {
                date: "2020-11-01T00:00:00+13:00",
                type: "d MMM y",
                trimester: "1",
              },
              custom: {
                content:
                  "Apply by 01 Jul 2021 and start studying once your application is accepted.",
              },
              international: false,
              domestic: true,
            },
          ],
          KDSAsset: "1787501",
          feeYear: "2020",
          feeLevies: "850",
          feeTuition: "7837.20",
          feePeriod: "per year",
          feeExtraCosts: "",
          internationalFeeTotal: "34400",
          internationalFeeTerm: "per 120 points",
          internationalFeeDuration: "",
          points: "360",
          partTimeQual: "yes",
          fullTimeQual: "yes",
          qualType: "research",
        }
      ];

      return [...array, ...phds];
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>